import {withStyles} from "@material-ui/core/styles";
import TreeItem from "@material-ui/lab/TreeItem";
import SearchInput from "./SearchInput";
import {TransitionComponent} from "./TreeUtils";
import React from "react";
import {Icon} from "@material-ui/core";
import {useDrag} from "react-dnd";
import findByString from "../../../../../Utils/Form/FormDynamic/Utils/getValueByString";
import {useSelector} from "react-redux";

const TreeItemSchemaProperty = withStyles((theme) => ({
    iconContainer: {
        '& .close': {
            opacity: 0.3,
        },
    },
    group: {
        marginLeft: 7,
        paddingLeft: 8,
        borderLeft: `1px dashed ${theme.palette.text.primary}`,
    },
    label: {
        '& $searchButton': {
            visibility: 'hidden'
        },
        '&:hover': {
            '& $searchButton': {
                visibility: 'visible'
            }
        }
    },
    searchButton: {
        display: 'flex',
        alignItems: 'center'
    }
}))((props) => {
    const appTree = useSelector(state => state.applicationBuilder.appTree);
    const selectedNodes = useSelector(state => state.applicationBuilder.selectedNodes);
    const [_, drag, preview] = useDrag({
        canDrag: props.source,
        item: {type: 'field'},
        begin: () => {
            const newPath = props.nodeId.split(".").slice(2, 4).join(".")
            const item = findByString(appTree, "0." + newPath)

            const selected = selectedNodes.length > 1 ? selectedNodes.map(item => {
                const fieldPath = item.split(".").slice(4).join(".").replace(/children/g, "properties");
                const field = findByString(appTree, "0." + newPath + "." + fieldPath)?.source;
                console.log(field)
                if (field) return Array.isArray(field) ? field.flat() : field;
            }) : props.source
            console.log(selected.flat())
            return {
                component: {
                    fields: Array.isArray(selected) ? selected.flat() : [selected],
                    _entity: item.id
                },
                dragType: 'multiple',
                type: "field",
            }
        },
        end: () => {
        }
    })
    return (
        <TreeItem
            {...props}
            label={
                <div
                    className={props.classes.label}
                    style={{display: 'flex', alignItems: 'center', justifyContent: 'space-between'}}>
                    <div style={{display: 'flex', alignItems: 'center', justifyContent: 'space-between'}}>
                        <Icon style={{color: '#b6b6b6', cursor: "grab", display: !props.source ? 'none' : 'block'}}
                              ref={drag}>
                            drag_indicator
                        </Icon>
                        <span>{props.label}</span>
                    </div>
                    {props.isRoot && (
                        <>
                            <div className={props.classes.searchButton}>
                                <SearchInput
                                    searchKey={props.searchKey} cssClass={props.classes.searchButton}
                                />
                            </div>
                        </>
                    )}
                </div>}
            TransitionComponent={TransitionComponent}
        />
    )
});
export default TreeItemSchemaProperty;